export { buildWidgetDragPayload } from './buildWidgetDragPayload'
export {
  canSaveWidgetOrder,
  selectDesktopWidgets
} from './desktopWidgetAdapter'
export { setDesktopWidgetsQueryData } from './setDesktopWidgetsQueryData'
export { normalizeDisplayOrder } from './normalizeDisplayOrder'
export { readWidgetPayload } from './readWidgetPayload'
export type { DroppedWidgetSpec } from './readWidgetPayload'
export { transformWidgetsForSave } from './transformWidgetsForSave'
